import { Equipment } from '@core/models/Equipment';
import { Professional } from '@core/models/Professional';
import { Referrer } from '@core/models/Referrer';
import { Service } from '@core/models/Service';
import { Moment } from 'moment';
import { Cabinet } from '@core/models/Cabinet';
import { Pack } from '@core/models/Pack';
import { Tag } from '@core/models/Tag';
import {SectionLock} from '@core/models/SectionLock';

export interface Clinic {
    id: string;
    name: string;
    openSaturday: boolean;
    openSunday: boolean;
    equipmentList: Equipment[];
    packs: Pack[];
    prefix: string;
    professionals: Professional[];
    referrers: Referrer[];
    services: Service[];
    laserSign: LASER_SIGN;
    loaded: boolean;
    openingTime: Moment;
    closingTime: Moment;
    weekdayOpeningTime: Moment;
    weekdayClosingTime: Moment;
    weekendOpeningTime: Moment;
    weekendClosingTime: Moment;
    cabinets: Cabinet[];
    tags: Tag[];
    pinRequiredSecs: string[];
    sectionsLocks: {
        documents: SectionLock;
        clientEdit: SectionLock;
    };
    isTeleconsulting?: boolean;
}

export const createClinic = (params: Partial<Clinic>): Clinic => ({
    id: params.id,
    name: params.name,
    openSaturday: false,
    openSunday: false,
    equipmentList: [],
    packs: [],
    prefix: params.prefix,
    professionals: [],
    referrers: [],
    services: [],
    laserSign: LASER_SIGN.NEVER,
    loaded: false,
    cabinets: [],
    tags: [],
    pinRequiredSecs: [],
    isTeleconsulting: params.isTeleconsulting ?? false,
} as Clinic);

export enum LASER_SIGN {
    ALWAYS = -2,
    OPTIONAL,
    NEVER
}
